'use client'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import CustomButton from '../common/CustomButton'
import { buttonsTypes } from '@/utils'
import { useRouter } from 'next/navigation'

// Render an error feedback screen with a dynamic message and a return link.
// errorMessage --- string dinamyc error message
const Error = ({ errorMessage, reset }) => {

  const router = useRouter()

  const back = () => router.back();

  return (
    <section className='w-auto h-auto flex flex-col items-center gap-y-2 px-6'>
      <Image
        src={'/assets/error.png'}
        width={400}
        height={100}
        alt='cloud error'
        className='w-80 md:w-96'
      />
      <h2 className='text-xl md:text-2xl font-semibold text-center'>{errorMessage}</h2>
      <h6 className='text-base font-semibold text-center text-gray-800'>Comentanos el error en la seccion de <Link href={'/'} className='font-semibold text-primary underline'>contacto</Link></h6>
      <div className='mt-4 flex gap-x-5'>
        <button type='button' onClick={back} className={`flex h-11 items-center justify-center border px-5 text-base font-semibold select-none focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800 rounded ${buttonsTypes.primaryLight}`}>Volver</button>
         <CustomButton action={reset} title='Reintentar' colorType='primary' />
      </div>
    </section>
  )
}

export default Error